var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-block"},[_c('ProgressSpinner',{staticStyle:{"width":"35px","height":"35px"},attrs:{"strokeWidth":"5"}}),(_vm.message)?_c('p',[_vm._v(_vm._s(_vm.message))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }